import { getJson, postJson, putJson, withDone, withOptional, withValidate } from '@rad/utility/http';
export const getPublishedAnnouncements = (page, pageSize, kind) => withDone(getJson(`/api/announcements/published`, { page, pageSize, kind }))();
export const getAnnouncements = (p) => getJson(`/api/announcements`, p);
export const getAnnouncement = (id) => withOptional(getJson(`/api/announcements/${id}`));
export const createAnnouncement = (a) => withDone(withValidate(postJson(`/api/announcements`, a)))();
export const updateAnnouncement = (a) => withDone(withValidate(putJson(`/api/announcements`, a)))();
export const getKinds = getJson(`/api/announcements/kinds`);
export const getStatuses = getJson(`/api/announcements/statuses`);
